import {BrowserModule} from '@angular/platform-browser';
import {LOCALE_ID, NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {CalculatorIndexComponent} from './calculator-index/calculator-index.component';
import {FormsModule} from "@angular/forms";
import {DafaultIfNullPipe} from './pipes/dafault-if-null.pipe';
import {DecimalPipe, registerLocaleData} from '@angular/common';
import localeDe from '@angular/common/locales/de';
import {UtilsService} from "./services/utils.service";
import {RciNumberFormatDirective} from './directives/rci-number-format.directive';
import {NouisliderModule} from "ng2-nouislider";
import {LoaderService} from "./services/loader.service";
import {LoaderInterceptorService} from "./services/loader-interceptor.service";
import {LoaderComponent} from "./loader/loader.component";

registerLocaleData(localeDe);


@NgModule({
  declarations: [
    AppComponent,
    CalculatorIndexComponent,
    DafaultIfNullPipe,
    RciNumberFormatDirective,
    LoaderComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    NouisliderModule
  ],
  providers: [
    UtilsService,
    DecimalPipe,
    LoaderService,
    {
      provide: LOCALE_ID,
      useValue: 'de-DE'
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptorService,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
